import { Tooltip as TooltipPrimitive } from "@base-ui/react/tooltip";
import { cn } from "../lib/cn";

function Tooltip({ ...props }: TooltipPrimitive.Root.Props) {
  return <TooltipPrimitive.Root data-slot="tooltip" {...props} />;
}

/**
 * What the hint is about. Renders a `<button>` unless given something else
 * through `render`, which is what a hint on a word inside a control wants.
 */
function TooltipTrigger({ ...props }: TooltipPrimitive.Trigger.Props) {
  return <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />;
}

/**
 * A hint is the one surface that is not a panel: it says a few words beside
 * something and takes nothing away from the page. So it wears the panel
 * materials at a smaller radius, and it arrives without the travel — a
 * surface that appears because a cursor paused should not announce itself.
 */
function TooltipContent({
  align = "center",
  side = "top",
  sideOffset = 6,
  className,
  ...props
}: TooltipPrimitive.Popup.Props &
  Pick<TooltipPrimitive.Positioner.Props, "align" | "side" | "sideOffset">) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Positioner
        className="isolate z-50 outline-none"
        align={align}
        side={side}
        sideOffset={sideOffset}
        collisionPadding={8}
      >
        <TooltipPrimitive.Popup
          data-slot="tooltip-content"
          className={cn(
            "overlay-hint max-w-64 rounded-xl bg-popover px-2.5 py-1.5 text-xs leading-snug text-pretty text-popover-foreground shadow-lg ring-1 ring-foreground/10 outline-none",
            className,
          )}
          {...props}
        />
      </TooltipPrimitive.Positioner>
    </TooltipPrimitive.Portal>
  );
}

export { Tooltip, TooltipContent, TooltipTrigger };
